import React from "react";
import { FaEnvelope, FaLock } from "react-icons/fa";

export default function SignInComponent({
  appName,
  tagline,
  email,
  password,
  setEmail,
  setPassword,
  formError,
  loading,
  onSubmit,
}) {
  return (
    <div className="fl-login-page">
      <div className="fl-login-card">

        {/* Logo Section */}
        <div className="fl-logo-section">
          <h1 className="fl-logo-text">{appName}</h1>
          <p className="fl-logo-tagline">{tagline}</p>
        </div>

        {/* Heading */}
        <h2 className="fl-welcome-title">Welcome Back</h2>
        <p className="fl-subtitle">Sign in to continue your order.</p>

        {/* Form Container */}
        <div className="fl-backdrop-container">

          {/* Email */}
          <div className="fl-input-box">
            <label className="fl-label">Email Address</label>

            <div className="fl-input-wrapper">
              <FaEnvelope className="fl-icon" />

              <input
                type="email"
                placeholder="example@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="fl-input-box">
            <label className="fl-label">Password</label>

            <div className="fl-input-wrapper">
              <FaLock className="fl-icon" />

              <input
                type="password"
                placeholder="*********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Error */}
          {formError && (
            <p className="fl-error-text">{formError}</p>
          )}

          {/* Button */}
          <button
            className="fl-signin-btn"
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>

        </div>

        {/* Support */}
        <p className="fl-support-text">
          Trouble signing in?{" "}
          <span className="fl-support-link">Contact support.</span>
        </p>

      </div>
    </div>
  );
}